
<template>
  <div :class="{ isNoticeHead: !$store.state.isIndexTopNotice, mainBody: $store.state.isIndexTopMainBody }"
    class="pt-4 pb-8 lg:py-6 xl:py-8 px-2 lg:px-8 max-w-5xl mx-auto text-NotoSansRegular" ref="breadcrumb" id="checkout">
    <Breadcrumb :stepNum="stepNum" v-if="stepNum !== 'step4'" />
    <!-- v-if="(stepNum === '' || stepNum === 'step2' || stepNum === 'step3') && $store.state.cart.num > 0 && products && (products.length > 0 || Object.keys(products).length > 0)" -->
    <!-- 第一步 -->
    <div v-if="!stepNum" class="step1 mx-auto">
      <div v-if="products !== null && (Object.keys(products).length > 0 || products.length > 0)">
        <h4 class="font-semibold text-center lg:text-lg textColorblack hidden lg:block">我的購物車</h4>
        <div class="flex mb-4 flex-wrap">
          <div class="w-full pb-2 md:pb-0">
            <div class="bg-white rounded md:p-4 flex flex-col justify-between leading-normal">
              <CartSection :products="products" v-on:cartListValue="judgeAPI" v-on:removeShopItem="removeShopItem" :events="events" :gifts="gifts" v-if="products !== null" />
            </div>
          </div>
          <div class="w-full" v-if="freeGift_data">
            <FreeGift v-for="(item, index) in freeGift_data" :key="index" class="mb-2 pb-2 md:pb-0"
              :giftData="item"
              v-on:getSelectGift="getSelectGift"
              :hasSelectedItems="getSelectGiftItem(item.id)"
              />
          </div>
        </div>
        <div v-if="!is_digital && !isOnlyCredit" class="md:px-6 hidden md:block">
          <div v-if="total < free_shipping">
            <p class="text-sm text-right textColorRed">只差 <span class="mx-1">NT$ {{ free_shipping - total }}</span> 可享滿 NT$ {{ free_shipping }} 免運</p>
          </div>
          <div v-else>
            <p class="text-sm text-right textColorRed">您已到達NT$ {{ free_shipping }} 免運門檻了</p>
          </div>
        </div>
        <div class="flex mb-4 flex-col md:flex-row md:border-b pb-6 md:pb-12">
          <div class="w-full md:w-1/2 mb-6 md:mb-0">
            <PaymentMethod v-on:paymentType="paymentType" :parentType="paymentInfo.payment" :CODisDisabled="isDisabledCOD" :isOnlyCredit="isOnlyCredit" :isOnlyCreditATM="isOnlyCreditATM" class="mb-2"/>
            <CouponInput v-on:setCoupon="setCoupon" :couponCode="paymentInfo.couponCode" class="md:mt-2 lg:mt-8"/>
          </div>
          <div class="w-full md:w-1/2 md:px-6">
            <div v-if="!is_digital && !isOnlyCredit" class="md:px-6 md:hidden">
              <div class="px-3" v-if="total < free_shipping">
                <p class="text-sm text-right textColorRed">只差 <span class="mx-1">NT$ {{ free_shipping - total }}</span> 可享滿 NT$ {{ free_shipping }} 免運</p>
              </div>
              <div class="px-3" v-else>
                <p class="text-sm text-right textColorRed">您已到達NT$ {{ free_shipping }} 免運門檻了</p>
              </div>
            </div>
            <Money :total="total"
              :eventDiscount="paymentInfo.eventDiscount"
              :shipping="paymentInfo.shipping_fee"
              :calcAmount="calcAmount"
              :percentage="paymentInfo.percentage"
              :magazine_shipping_fee="paymentInfo.magazine_shipping_fee" />
          </div>

        </div>
        <div class="flex justify-center md:pt-6">
          <router-link :to="{ name: 'index' }" class="py-2 px-12 rounded md:mr-4 hidden md:block border button-black">
            繼續訂購
          </router-link>
          <button class="button-red text-white py-2 px-16 rounded md:ml-4 w-full md:w-auto"
            @click="toStep2">
              下一步
          </button>
        </div>
        <div class="flex justify-center mt-4 px-4 md:hidden">
          <router-link :to="{ name: 'index' }" class="py-2 px-12 rounded md:mr-4 underline text-center">
            繼續訂購
          </router-link>
        </div>
      </div>

      <div v-else class="border-b textColorDarkBlack">
        <h1 class="mb-12 text-center text-NotoSansRegular">訂購商品檢視</h1>
        <p class="text-center text-3xl md:text-4xl mb-1 text-NotoSansRegular font-bold">Oops!</p>
        <p class="text-center text-base md:text-xl mb-8 md:mb-12 text-NotoSansRegular">您還沒有將商品加入到購物車中</p>
        <div class="back w-full flex justify-center mb-8 md:mb-24">
          <router-link :to="{ name: 'index' }" class="button-red py-2 px-8 rounded text-white mx-auto ttext-NotoSansRegular">
            繼續訂購
          </router-link>
        </div>
      </div>

      <RelatedEvents :title="'館內特惠活動！'"/>
    </div>
    <!-- 第二步 -->
    <div v-if="stepNum === 'step2' && cartList && cartList.length > 0 && status.isShopping" class="step2 mx-auto border-t pt-4">

      <CaptchaPop
        v-if="isShowCaptchaVerify"
        v-on:closeEmailPop="closeEmailPop"
        v-on:isCodeVerify="isCodeVerify"
        :email="shoppingInfo.user.email"
        :verifyStatus="verifyStatus" />
      <!-- 基本資料 -->
      <form action="javascript:void(0);" class="text-NotoSansRegular textColorblack mx-auto max-w-4xl">
        <div class="w-full bg-white rounded py-2 lg:p-4 flex flex-col justify-between leading-normal" >
          <div class="flex flex-wrap textColorblack" ref="orderer">
            <!-- 訂購人姓名 -->
            <div class="px-3 mb-4 md:mb-6 w-full md:w-4/5">
              <h5 class="md:pt-2 text-base border-b text-center tracking-wider pb-3">
                訂購人資料
              </h5>
            </div>
              <!-- 更新會員資料 -->
              <div class="w-full items-center px-4 lg:px-6 flex md:mb-2" v-if="authorized">
                <div class="controls-item w-full md:w-4/5 flex justify-end">
                  <input :class="{ labelisTrue: isUpdatedMember }" id="updatMemberData" name="updatMemberData"
                    type="checkbox" class="checkbox hidden" v-model="isUpdatedMember">
                  <label for="updatMemberData">
                    <span class="text-sm w-full ml-2">
                      更新會員資料
                    </span>
                  </label>
                </div>
              </div>

            <div class="w-full px-3 mb-2 md:mb-4 md:flex" ref="name">
              <label class="md:flex items-center text-sm md:text-base md:w-1/5 tracking-wide" for="menmberName">
                訂購人姓名
                <span class="textColorRed">*</span>
              </label>
              <input class="md:w-3/5 appearance-none border-gray-500 focus:border-gray-900 block w-full  text-sm border rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                id="menmberName" type="text" @blur="checkField('userName')" placeholder="請輸入收件人姓名" v-model.trim="shoppingInfo.user.name" :class="{ borderRed: !validation.name }" maxlength="15">
            </div>
            <!-- 訂購人手機 -->
            <div class="w-full px-3 mb-2 md:mb-4 md:flex" ref="phone">
              <label class="md:flex items-center md:text-base md:w-1/5 tracking-wide text-sm" for="memberPhone">
                訂購人手機
                <span class="textColorRed">*</span>
              </label>
              <div class="md:w-3/5 flex">
                <div class="w-1/3 relative pr-1">
                  <select v-model="shoppingInfo.user.country_code" class="block appearance-none w-full text-sm border border-gray-500 py-3 px-4 pr-8 rounded leading-tight focus:outline-none bg-white focus:border-gray-900" id="invoice"
                    >
                    <option :value="item.phoneCode" v-for="(item, index) in countryJson" :key="index">{{ item.countryName }}({{ item.phoneCode }})</option>
                  </select>
                  <div class=" pointer-events-none absolute inset-y-0 right-0 flex items-center px-1 md:px-2">
                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                  </div>
                </div>
                <div class="w-2/3">
                  <input class="w-full appearance-none border-gray-500 focus:border-gray-900 block  text-sm border rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                  id="memberPhone" type="tel" placeholder="ex: 0900123456" maxlength="10" v-model.trim="shoppingInfo.user.phone" :class="{ borderRed: !validation.phone }">
                  <p class="textColorRed text-right text-xs"  v-if="!validation.phoneRex">手機格式錯誤</p>
                </div>

              </div>
            </div>

            <!-- 市內電話 -->
            <!-- <div class="w-full px-3 md:flex mb-2 md:mb-4" ref="homeTel">
              <label class="md:flex items-center md:w-1/5 tracking-wide text-sm md:text-base" for="memberTel">
                市內電話
              </label>
              <input class="md:w-3/5 appearance-none border-gray-500 focus:border-gray-900 block w-full  text-sm border rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                id="memberTel" type="tel" @blur="checkField('userTel')" placeholder="" v-model.trim="shoppingInfo.user.tel" :class="{ borderRed: !validation.tel }">
            </div> -->
            <!-- 收件人地址 -->
            <div class="w-full px-3 md:mb-4 flex flex-wrap md:flex-no-wrap">
              <div class="w-full md:w-1/5 md:mb-0 md:flex items-center">
                <label class="md:text-base block uppercase tracking-wide text-sm" for="memberAddress">
                  訂購人地址
                  <span class="textColorRed">*</span>
                </label>
              </div>
              <div class="w-full md:w-3/5  md:mb-0">
                <Address v-on:getAddress="getOrderAddress" :isValidate="validation.isCityDistrict"
                :userCity="shoppingInfo.user.city"
                :userDistrict="shoppingInfo.user.district" />
              </div>
            </div>
            <div class="w-full px-3 md:flex" ref="addressText">
              <label class="md:pt-2 opacity-0 md:text-base md:w-1/5 tracking-wide text-sm hidden md:block" for="inputAddress">
                訂購人地址
                <span class="textColorRed">*</span>
              </label>
              <input class="md:w-3/5 appearance-none block w-full  text-sm border border-gray-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-900"
                id="inputAddress" type="text" placeholder="請輸入地址" v-model.trim="shoppingInfo.user.address"
                :class="{ borderRed: !validation.address }" name="inputAddress" @blur="checkField('userAddress')">
            </div>
          </div>
        </div>

        <div class="w-full bg-white rounded py-2 lg:p-4 flex flex-col justify-between leading-normal">
          <div class="flex flex-wrap textColorblack">
            <!-- 信箱/未登入 -->
            <div class="w-full px-3 mb-2 md:mb-4 md:flex" v-if="!authorized">
              <label class="md:pt-2 md:text-base md:w-1/5 tracking-wide text-sm mb-2" for="menmberEmail">
                會員信箱<span class="textColorRed">*</span><img src="@/assets/icon/check_circle.png" class="object-contain ml-1 md:hidden" v-if="validation.isEmailVerify">
              </label>
              <div class="w-full md:w-3/5">
                <input class="w-full appearance-none block text-sm border border-gray-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-900" spellcheck="false"
                  id="menmberEmail" type="email" placeholder="" v-model.trim="shoppingInfo.user.email" :disabled="validation.isEmailVerify"
                  :class="{ borderRed: !validation.email }" @blur="checkField('userMail')">
                  <p class="text-xs textColorRed tracking-wider" :class="{ hidden: validation.isEmailVerify }">
                    <font-awesome-icon icon="exclamation-circle" class="mr-1" />
                    <span>使用hotmail有可能收不到驗證信，建議使用gmail信箱</span>
                  </p>
                  <p class="text-xs textColorRed tracking-wider" :class="{ hidden: validation.isEmailVerify }">
                    <font-awesome-icon icon="exclamation-circle" class="mr-1" />
                    <span>一直沒收到驗證信，有可能跑到垃圾信件或被擋信了喔</span>
                  </p>
              </div>
              <div class="w-full md:w-1/5 flex flex-col justify-start">
                <button class="text-sm mt-1 md:mt-0 md:ml-2 button-red py-2 px-3 rounded text-white w-full md:w-auto block whitespace-no-wrap"
                  @click="verifyEmail" :class="{ hidden: validation.isEmailVerify }" ref="verifyEmail" :disabled="status.isCheckingAccount">
                  驗證電子信箱
                  <font-awesome-icon icon="circle-notch" spin v-if="status.isCheckingAccount" />
                </button>
                <div class="textColorRed text-xs md:pl-2 text-right md:text-left" v-if="!validation.emailRex">Email格式錯誤</div>
                <div class="textColorRed text-xs md:pl-2 text-right md:text-left" v-if="!validation.isEmailVerify">尚未驗證</div>
                <div class="h-full text-xs items-center md:pl-2 justify-end md:justify-start hidden md:block"
                  v-if="validation.isEmailVerify">
                  <img src="@/assets/icon/check_circle.png" class="object-contain mr-1 mt-1">
                </div>
              </div>

            </div>
            <!-- 信箱/已登入 -->
            <div class="w-full px-3 mb-2 md:mb-4 md:flex" v-if="authorized">
              <label class="md:pt-2 md:text-base md:w-1/5 tracking-wide text-sm flex" for="menmberEmail">
                會員信箱<span class="textColorRed">*</span><img src="@/assets/icon/check_circle.png" class="object-contain ml-1 md:hidden" v-if="validation.isEmailVerify">
              </label>
              <div class="w-full md:w-3/5 flex items-start justify-between flex-wrap md:flex-no-wrap">
                <input class="w-full cursor-default appearance-none block text-sm border border-gray-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-900"
                  id="menmberEmail" type="email" v-model.trim="shoppingInfo.user.email" readonly disabled
                  :class="{ borderRed: !validation.email }">
              </div>
              <div class="w-full md:w-1/5 flex flex-col justify-center">
                <button class="text-sm mt-1 md:mt-0 md:ml-2 button-red py-2 px-3 rounded text-white w-full md:w-auto block whitespace-no-wrap"
                  @click="userVerifyEmail" :class="{ hidden: validation.isEmailVerify }" ref="verifyEmail" v-if="!user.email_verified_at" :disabled="status.isCheckingAccount">
                  驗證電子信箱
                  <font-awesome-icon icon="circle-notch" spin v-if="status.isCheckingAccount" />
                </button>
                <div class="textColorRed text-xs md:pl-2 text-right md:text-left" v-if="!user.email_verified_at">尚未驗證</div>
                <div class="text-xs items-center md:pl-2 justify-end md:justify-start text-successGreen hidden md:block"
                  v-if="validation.isEmailVerify">
                  <img src="@/assets/icon/check_circle.png" class="object-contain mr-1">
                </div>
              </div>
            </div>
            <!-- 密碼 -->
            <div class="w-full px-3 mb-2 md:mb-4 md:flex" v-if="!authorized">
              <label class="md:pt-2 md:text-base md:w-1/5 tracking-wide text-sm" for="firstShoppingPwd">
                設定密碼
                <span class="textColorRed">*</span>
              </label>
              <input class="md:w-3/5 appearance-none block w-full  text-sm border border-gray-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-900"
                id="firstShoppingPwd" type="password" @blur="checkField('password')" placeholder="請輸入8碼至15碼英數字" v-model.trim="shoppingInfo.user.pwd"
                :class="{ borderRed: !validation.pwd }" autocomplete="old-password" maxlength="15" name="firstShoppingPwd">
            </div>
            <div class="w-full px-3 mb-2 md:mb-4 md:flex -mt-2 md:-mt-4" v-if="!validation.pwdRex">
              <div class="md:w-1/5"></div>
              <div class="md:w-3/5 textColorRed text-right text-xs">請輸入8碼至15碼英數字</div>
            </div>
            <div class="w-full px-3 mb-2 md:mb-4 md:flex" v-if="!authorized">
              <label class="md:pt-2 md:text-base md:w-1/5 tracking-wide text-sm" for="firstShoppingPwd_check">
                密碼確認
                <span class="textColorRed">*</span>
              </label>
              <input class="md:w-3/5 appearance-none block w-full  text-sm border border-gray-500 rounded py-3 px-4 eading-tight focus:outline-none focus:bg-white focus:border-gray-900"
                id="firstShoppingPwd_check" type="password" @blur="checkField('passwordCheck')" placeholder="再次輸入密碼" v-model.trim="shoppingInfo.user.pwdCheck"
                :class="{ borderRed: !validation.pwdCheck }" autocomplete="check-password" maxlength="15">
            </div>
            <div class="w-full px-3 mb-2 md:mb-4 md:flex -mt-2 md:-mt-4" v-if="!validation.pwdEqal">
              <div class="md:w-1/5"></div>
              <div class="md:w-3/5 textColorRed text-right text-xs">密碼不一致</div>
            </div>
          </div>
        </div>

        <!-- 收件人資料 -->
        <div class="recipient py-6" ref="recipientForm">
          <SelectAddress v-if="isSelectAddress" v-on:closeSelectAddress="closeSelectAddress" v-on:selectedAdd="selectedAdd" />

          <div class="w-full bg-white rounded py-2 lg:p-4 flex flex-col justify-between leading-normal">
            <div class="flex flex-wrap textColorblack">
              <div class="px-3 mb-4 md:mb-6 w-full md:w-4/5">
                <h5 class="md:pt-2 text-base border-b text-center tracking-wider pb-3">
                  收件人資料
                </h5>
              </div>
              <div class="w-full lg:w-4/5 px-3 mb-4 md:mb-6 lg:flex">
                <div class="flex lg:w-1/2">
                  <a @click="setSamePeopleData" class="p-1 border border-gray-600 text-sm rounded cursor-pointer">同訂購人資料</a>
                  <!-- <div class="controls-item w-full flex justify-start">
                    <input :class="{ labelisTrue: shoppingInfo.isSamePeople }" id="isSamePeople" name="isSamePeople"
                      type="checkbox" class="checkbox hidden" v-model="shoppingInfo.isSamePeople" @change="setSamePeopleData">
                    <label for="isSamePeople">
                      <span class="text-sm w-full ml-2">
                        同訂購人資料
                      </span>
                    </label>
                  </div> -->
                </div>

                <div class="flex items-center px-2 flex-wrap lg:w-1/2 justify-end" v-if="authorized && !shoppingInfo.isSamePeople">
                  <div class="w-full md:w-4/5 flex justify-end">
                    <a class="text-sm underline cursor-pointer" @click="isSelectAddress = true">從最近收件地址挑選</a>
                  </div>
                </div>
              </div>
              <div class="w-full px-3 mb-2 md:mb-4 md:flex" ref="getname">
                <label class="text-sm md:text-base md:w-1/5 tracking-wide md:flex items-center" for="getName">
                  收件人姓名
                  <span class="textColorRed">*</span>
                </label>
                <input class="md:w-3/5 appearance-none border-gray-500 focus:border-gray-900 block w-full  text-sm border rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                  id="getName" type="text"  @blur="checkField('recipientName')" placeholder="請輸入收件人姓名" v-model="shoppingInfo.recipient.name" :class="{ borderRed: !validation.recipient_name }" @change="setAddressId" maxlength="10">
              </div>
              <div class="w-full px-3 mb-2 md:mb-4 md:flex" ref="getphone">
                <label class="md:text-base md:w-1/5 tracking-wide text-sm md:flex items-center" for="getphone">
                  收件人手機
                  <span class="textColorRed">*</span>
                </label>
                <div class="md:w-3/5 flex">
                  <div class="w-1/3 relative pr-1">
                    <select v-model="shoppingInfo.recipient.country_code" class="block appearance-none w-full text-sm border border-gray-500 py-3 px-4 pr-8 rounded leading-tight focus:outline-none bg-white focus:border-gray-900" id="invoice"
                      >
                      <option :value="item.phoneCode" v-for="(item, index) in countryJson" :key="index">{{ item.countryName }}({{ item.phoneCode }})</option>
                    </select>
                    <div class=" pointer-events-none absolute inset-y-0 right-0 flex items-center px-1 md:px-2">
                      <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                    </div>
                  </div>
                  <div class="w-2/3">
                    <input class="w-full appearance-none border-gray-500 focus:border-gray-900 block text-sm border rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="getphone" type="tel" placeholder="收件人手機" maxlength="10" v-model="shoppingInfo.recipient.phone" :class="{ borderRed: !validation.recipient_phone }" @change="setAddressId">
                    <p class="textColorRed text-right text-xs"  v-if="!validation.recipient_rexPhone">手機格式錯誤</p>
                  </div>

                  <!-- <input class="w-2/3 appearance-none border-gray-500 focus:border-gray-900 block  text-sm border rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                  id="memberPhone" type="tel" @blur="checkField('userPhone')" placeholder="ex: 0900123456" v-model.trim="shoppingInfo.user.phone" :class="{ borderRed: !validation.phone }"> -->
              </div>
                <!-- <input :disabled="shoppingInfo.isSamePeople" class="md:w-3/5 appearance-none border-gray-500 focus:border-gray-900 block w-full text-sm border rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                  id="getphone" type="tel" @blur="checkField('recipientPhone')" placeholder="ex: 0900123456" v-model="shoppingInfo.recipient.phone" :class="{ borderRed: !validation.recipient_phone }" @change="setAddressId"> -->
              </div>
              <!-- 收件人市內電話 -->
              <div class="w-full px-3 mb-2 md:mb-4 md:flex" ref="homeTel">
                <label class="md:text-base md:w-1/5 tracking-wide text-sm md:flex items-center" for="recipientTel">
                  市內電話
                  <!-- <span class="textColorRed">*</span> -->
                </label>
                <input class="md:w-3/5 appearance-none border-gray-500 focus:border-gray-900 block w-full  text-sm border rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                  id="recipientTel" type="tel" @blur="checkField('recipientTel')" placeholder="" v-model.trim="shoppingInfo.recipient.tel" :class="{ borderRed: !validation.recipient_tel }" @change="setAddressId" maxlength="20">
              </div>
              <!-- 收件人地址 -->
              <div class="w-full px-3 md:mb-4 flex flex-wrap md:flex-no-wrap">
                <div class="w-full md:w-1/5 md:mb-0 md:flex items-center">
                  <label class="md:text-base block uppercase tracking-wide text-sm" for="getAddress">
                    收件人地址
                    <span class="textColorRed">*</span>
                  </label>
                </div>
                <div class="w-full md:w-3/5 md:mb-0">
                  <Address
                    v-on:getAddress="getAddressRecipient" :isValidate="validation.recipient_cityDistrict"
                    :userCity="shoppingInfo.recipient.city"
                    :userDistrict="shoppingInfo.recipient.district"
                    :isDisabled="false" />
                </div>
              </div>
              <div class="w-full px-3 md:flex" ref="inputGetAddress">
                <label class="opacity-0 md:text-base md:w-1/5 tracking-wide text-sm hidden md:block" for="inputGetAddress">
                  收件人地址
                </label>
                <input class="md:w-3/5 appearance-none block w-full  text-sm border border-gray-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-900"
                  id="inputGetAddress" type="text" @blur="checkField('recipientAddress')" placeholder="請輸入地址" v-model="shoppingInfo.recipient.address" :class="{ borderRed: !validation.recipient_address }"
                  name="address" @change="setAddressId">
              </div>
              <div class="w-full px-3 md:flex" v-if="paymentInfo.payment !== 'COD'">
                <div class="md:w-1/5"></div>
                <div class="md:w-3/5 text-xs">※若收件地址為郵政信箱，請於備註欄填寫</div>
              </div>
              <div class="w-full px-3 md:flex" v-if="!validation.recipient_notmailAddress && paymentInfo.payment === 'COD'">
                <div class="md:w-1/5"></div>
                <div class="md:w-3/5 text-xs">※貨到付款請勿填寫郵政信箱</div>
              </div>
              <div class="w-full px-3 md:flex" v-if="!validation.isCODandOutland && paymentInfo.payment === 'COD'">
                <div class="md:w-1/5"></div>
                <div class="md:w-3/5 text-xs textColorRed">付費方式不支援外島寄送</div>
              </div>

              <!-- 校園部活動填寫學校 -->
              <div class="w-full px-3 md:flex mt-2 md:mt-4" ref="getname" v-if="isOnlyCredit">
                <label class="text-sm md:text-base md:w-1/5 tracking-wide md:flex items-center" for="getName">
                  就讀高中／職
                  <span class="textColorRed">*</span>
                </label>
                <input class="md:w-3/5 appearance-none border-gray-500 focus:border-gray-900 block w-full  text-sm border rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                  id="getName" type="text" placeholder="請填寫學校單位" v-model="shoppingInfo.school" maxlength="50" @blur="checkField('school')" :class="{ borderRed: !validation.school }">
              </div>
              <div class="w-full px-3 md:flex mb-2 md:mb-4" v-if="!validation.school">
                <div class="md:w-1/5"></div>
                <div class="md:w-3/5 text-xs textColorRed">請填寫學校單位</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 發票 -->
        <div class="w-full textColorblack rounded py-2 lg:p-4 flex flex-col justify-between leading-normal" ref="eGUI">
          <div class="px-3 mb-4 md:mb-6 w-full md:w-4/5">
            <h5 class="md:pt-2 text-base border-b text-center tracking-wider pb-3">
              電子發票設定
            </h5>
          </div>
          <div class="px-2 w-full md:w-4/5">
            <ul class='flex cursor-pointer text-center text-sm'>
              <li class='py-2 md:py-3 text-center border flex-1 tracking-wider' :class="{ choose: shoppingInfo.delivery.eGUIType === 0 }" @click.prevent="setInvoiceType(0)">個人電子發票</li>
              <li class='py-2 md:py-3 text-center border flex-1 tracking-wider' :class="{ choose: shoppingInfo.delivery.eGUIType === 2 }" @click.prevent="setInvoiceType(2)">公司戶電子發票</li>
            </ul>
          </div>
          <div class="invoice-content p-2 py-4">
            <!-- 發票存取方式 -->
            <div class="w-full px-3 md:flex mb-2 md:mb-4">
              <label class="md:pt-2 md:text-base md:w-1/5 tracking-wide text-sm" for="invoice">
                發票存取方式
              </label>
              <div class="md:w-3/5 relative text-sm">
                <select class="block appearance-none w-full  border border-gray-500 py-3 px-4 pr-8 rounded leading-tight focus:outline-none bg-white focus:border-gray-900" id="invoice"
                  v-model="shoppingInfo.delivery.invoice_type" @change="setInvoiceUser">
                  <option value="31">會員載具</option>
                  <option value="32">自然人憑證條碼</option>
                  <option value="33">手機條碼</option>
                  <option value="330" v-if="shoppingInfo.delivery.eGUIType === 2">手機條碼+紙本電子發票證明聯</option>
                  <option value="0" v-if="shoppingInfo.delivery.eGUIType === 2">紙本電子發票證明聯</option>
                </select>
                <div class=" pointer-events-none absolute inset-y-0 right-0 flex items-center px-1 md:px-2">
                  <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>
            <!-- 電子發票(自然人憑證條碼) -->
            <div v-if="shoppingInfo.delivery.invoice_type === '32'">
              <div class="w-full px-3 md:flex mb-2 md:mb-4">
                <label class="md:pt-2 md:text-base md:w-1/5 tracking-wide text-sm hidden md:block" for="citizenDigitalCertify">
                  自然人憑證條碼
                </label>
                <div class="w-full md:w-3/5">
                  <span class="label-helper block textColorDarkBlack text-xs tracking-wider">請輸入自然人憑證條碼(前兩碼為大寫英文【A-Z】，後14碼為數字【0-9】</span>
                  <input type="text" class="appearance-none block w-full text-sm border border-gray-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-900"
                    maxlength="16" id="citizenDigitalCertify" @blur="checkField('NaturalPersonCertify')" autocomplete="off"  name="account" v-on:keyup.13="codeCheck" v-model.trim="shoppingInfo.delivery.invoice_carrier" :class="{ borderRed: !validation.invoice_carrier }" />
                </div>
              </div>
              <div class="w-full px-3 mb-2 md:mb-4 md:flex -mt-2 md:-mt-4" v-if="!validation.rex_invoice_carrier">
                <div class="md:w-1/5"></div>
                <div class="md:w-3/5 textColorRed text-right text-xs">「自然人憑證條碼」格式錯誤</div>
              </div>
            </div>
            <!-- 手機條碼 -->
            <div v-if="shoppingInfo.delivery.invoice_type === '33' || shoppingInfo.delivery.invoice_type === '330'">
              <div class="w-full px-3 md:flex mb-2 md:mb-4">
                <label class="md:pt-2 md:text-base md:w-1/5 tracking-wide text-sm" for="mobileBarcode">
                  手機條碼
                </label>
                <div class="w-full md:w-3/5">
                  <span class="label-helper block textColorDarkBlack text-xs tracking-wider">輸入手機條碼(第一碼必為"/"，其餘七碼則由數字【0-9】、大寫英文【A-Z】與特殊符號【.】【-】【+】組成</span>
                  <input type="text" class="appearance-none block w-full text-sm border border-gray-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-900"
                    id="mobileBarcode" @blur="checkField('MobilePhoneBarcode')" autocomplete="off" name="account" v-on:keyup.13="codeCheck" placeholder="輸入手機條碼" maxlength="8" v-model.trim="shoppingInfo.delivery.invoice_carrier" :class="{ borderRed: !validation.invoice_carrier || !validation.rex_invoice_carrier }" spellcheck="false" />
                </div>
              </div>
              <div class="w-full px-3 mb-2 md:mb-4 md:flex -mt-2 md:-mt-4" v-if="!validation.rex_invoice_carrier || !validation.isBarCode">
                <div class="md:w-1/5"></div>
                <div class="md:w-3/5 textColorRed text-right text-xs" >
                <p v-if="!validation.rex_invoice_carrier">「手機條碼」格式錯誤</p>
                <p v-if="!validation.isBarCode">「手機條碼」未註冊，請輸入正確的手機條碼</p>
                </div>
              </div>
            </div>
            <!-- 我要捐贈發票 -->
            <div class="controls-item w-full px-3 mb-2 md:flex" v-if="shoppingInfo.delivery.eGUIType === 0">
              <div>
                <input :class="{ labelisTrue: shoppingInfo.delivery.invoice_giving }" id="agreeGiving" name="agreeGiving"
                  type="checkbox" class="checkbox hidden" v-model="shoppingInfo.delivery.invoice_giving">
                <label for="agreeGiving">
                  <span class="text-sm w-full ml-2">
                    我要捐贈發票
                  </span>
                </label>
              </div>
              <div class="md:ml-5" v-if="!shoppingInfo.delivery.invoice_giving">
                <input :class="{ labelisTrue: isSameShoppingInfoAddress }" id="sameAgreeGiving" name="sameAgreeGiving"
                  type="checkbox" class="checkbox hidden" v-model="isSameShoppingInfoAddress" @change="setInvoice_address">
                <label for="sameAgreeGiving">
                  <span class="text-sm w-full ml-2">
                    同訂購人地址
                  </span>
                </label>
              </div>
            </div>
            <!-- 中獎寄送地址 -->
            <div class="w-full px-3 md:mb-4 flex flex-wrap md:flex-no-wrap" v-if="shoppingInfo.delivery.eGUIType === 0 && shoppingInfo.delivery.invoice_type === '31' && !shoppingInfo.delivery.invoice_giving">
              <div class="w-full md:w-1/5 md:mb-0">
                <label class="md:pt-2 md:text-base block uppercase tracking-wide text-sm"
                  for="memberAddress">
                  中獎寄送地址
                </label>
              </div>
              <div class="w-full md:w-3/5 md:mb-0">
                <Address
                  v-on:getAddress="getWinAddress" :isValidate="validation.invoice_cityDistrict"
                  :userCity="shoppingInfo.delivery.invoice_city"
                  :userDistrict="shoppingInfo.delivery.invoice_district"
                  :isDisabled="isSameShoppingInfoAddress" />
              </div>
            </div>
            <div class="w-full px-3 md:flex mb-4 md:mb-4" v-if="shoppingInfo.delivery.eGUIType === 0 && shoppingInfo.delivery.invoice_type === '31' && !shoppingInfo.delivery.invoice_giving">
              <label class="md:pt-2 opacity-0 md:text-base md:w-1/5 tracking-wide text-sm hidden md:block" for="invoice_address">
                中獎寄送地址
              </label>
              <input :disabled="isSameShoppingInfoAddress" class="md:w-3/5 appearance-none block w-full  text-sm border border-gray-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-900"
                id="invoice_address" type="text" placeholder=""  @blur="checkField('invoice_address')" v-model.trim="shoppingInfo.delivery.invoice_address"  :class="{ borderRed: !validation.invoice_address && invoice_carrier_type === '1' }">
            </div>
            <!-- 受贈機關或團體 -->
            <div v-if="shoppingInfo.delivery.invoice_giving">
              <div>
                <div class="w-full px-3 md:flex mb-2 md:mb-4">
                  <label class="md:pt-2 md:text-base md:w-1/5 tracking-wide text-sm" for="donation">
                    受贈機關或團體
                  </label>
                  <div class="md:w-3/5 text-sm h-10">
                    <VueSelectComponent :data="loveCode" :userDonation="shoppingInfo.delivery.invoice_donation" v-on:inputLoveCode="inputLoveCode" class="donat-selector border rounded border-gray-500 py-3 px-2" :class="{ borderRed: !validation.isInputLoveCode }" />
                    <p v-if="!validation.invoice_donation" class="textColorRed text-right text-xs">此欄位不能空白</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- 公司戶電子發票 -->
            <div v-if="shoppingInfo.delivery.eGUIType === 2">
              <div class="w-full px-3 md:flex mb-2 md:mb-4">
                <label class="md:pt-2 md:text-base md:w-1/5 tracking-wide text-sm" for="taxID">
                  統一編號
                </label>
                <input class="w-full md:w-3/5 appearance-none block text-sm border border-gray-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-900"
                  id="taxID" type="text" @input="handleInputNumber" @blur="checkField('taxNum')" autocomplete="off" placeholder="" v-model.trim="shoppingInfo.delivery.taxNum" :class="{ borderRed: !validation.taxNum }" maxlength="8">
              </div>
              <div class="w-full px-3 mb-2 md:mb-4 md:flex -mt-2 md:-mt-4" v-if="!validation.taxNum">
                <div class="md:w-1/5"></div>
                <div class="md:w-3/5 textColorRed text-right text-xs">請輸入統一編號共8碼</div>
              </div>
              <div class="w-full px-3 md:flex mb-2 md:mb-4">
                <label class="md:pt-2 md:text-base md:w-1/5 tracking-wide text-sm" for="invoiceName">
                  發票抬頭
                </label>
                <input class="md:w-3/5 appearance-none block w-full  text-sm border border-gray-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-900"
                  id="invoiceName" type="text" autocomplete="off" @blur="checkField('taxName')" placeholder="" v-model.trim="shoppingInfo.delivery.taxName" :class="{ borderRed: !validation.taxName }" maxlength="30">
              </div>
              <div class="w-full px-3 mb-2 md:mb-4 text-sm">
                <p>*提醒：因商城中包含應/免稅商品，發票亦會分成應/免稅開立，請留意。</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 同意辦理退貨 -->
        <div class="mb-4 px-4 lg:px-6 pb-4 lg:pb-6">
          <div class="items-center pb-1 lg:px-6 flex">
            <div class="controls-item w-full md:w-4/5">
              <input :class="{  labelisTrue: shoppingInfo.invoice_auth }" id="agreeReturn" name="agreeReturn"
                type="checkbox" class="checkbox hidden" v-model="shoppingInfo.invoice_auth">
              <label for="agreeReturn">
                <span class="text-sm w-full ml-2">
                  我同意辦理退貨時，由LiveABC代為處理發票及銷貨退回證明單，以加速退貨退款作業；如有開立抬頭統編(公司戶發票)，仍需開立紙本折讓。依統一發票使用辦法規定：個人發票一經開立，無法更改或改開公司戶發票。
                </span>
              </label>
            </div>
          </div>
          <div class="pb-1 px-4 lg:px-10">
            <a href="https://www.einvoice.nat.gov.tw/?CSRT=6201288656407980614" target="_blank" class="underline text-sm text-blue-500">依財政部雲端發票流程說明</a>
          </div>
        </div>

        <!-- 備註 -->
        <div class="mb-4 w-full textColorblack rounded py-2 lg:p-4 flex flex-col justify-between leading-normal">
          <div class="w-full px-3 md:flex">
            <label class="md:text-base md:w-1/5 tracking-wide text-sm" for="shoppingInfo.remark">
              備註事項
            </label>
            <textarea id="shoppingInfo.remark" v-model="shoppingInfo.remark"
              class="md:w-3/5 p-1 resize border border-gray-500 rounded focus:border-gray-700 focus:outline-none focus:shadow-outline w-full"></textarea>
          </div>
        </div>

        <div class="mb-4 px-4 lg:px-6 pb-4 lg:pb-6">
        <!-- 接收優惠 -->
        <div class="items-center px-4 lg:px-6 flex pb-1" v-if="!authorized || (authorized && !user.isAgreeReceiveDM)">
          <div class="controls-item">
            <input id="get-mail" name="subscribe" type="checkbox" class="checkbox hidden" v-model="shoppingInfo.isAgreeReceiveDM" :class="{ labelisTrue: shoppingInfo.isAgreeReceiveDM }">
            <label for="get-mail">
              <span class="text-sm ml-2">我同意接收優惠訊息</span>
            </label>
          </div>
        </div>
        <!-- 同意條款 -->
        <div class="items-center pb-1 lg:px-6 flex">
          <div class="controls-item">
            <input :class="{ labelisTrue: shoppingInfo.isAgreePolicy }" id="agreePolicy" name="agreePolicy"
              type="checkbox" class="checkbox hidden" v-model="shoppingInfo.isAgreePolicy">
            <label for="agreePolicy">
              <span class="text-sm w-full ml-2">
                我同意接受LiveABC
                <router-link :to="{ name: 'policy' }" class="underline">服務條款</router-link>
                與
                <router-link :to="{ name: 'privacy' }" class="underline">隱私權政策</router-link>
              </span>
            </label>
          </div>
        </div>

          <!-- 同意數位產品合約 -->
          <div v-if="agreements && agreements.length > 0">
            <div class="items-center px-4 lg:px-6 flex pb-1"  v-for="(item, index) in agreements" :key="index">
              <div class="controls-item">
                <input
                :id="'agreeContract' + index"
                :name="'agreeContract' + index"
                type="checkbox" class="checkbox hidden"
                v-model="item.isAgree"
                :class="{ labelisTrue: item.isAgree }">
                <label :for="'agreeContract' + index">
                  <span class="text-sm ml-2">
                    我同意接受LiveABC
                    <a :href="item.url" target="_blank" class="underline">{{ item.title }}</a>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </form>

      <div class="flex md:mb-4 justify-center w-full lg:pt-6 lg:border-t border-gray-400 px-3">
        <router-link :to="{ name: 'checkout' }" class="md:mr-4 button-black py-2 px-8 md:px-12 rounded hidden md:block"
          @click.native="toStep1">
          回上頁
        </router-link>

        <button class="md:ml-4 button-red py-2 px-8 md:px-12 rounded text-white w-full md:w-auto" @click="toStep3()">
          下一步
        </button>
      </div>
      <div class="flex justify-center mt-4 px-4 md:hidden">
        <router-link :to="{ name: 'checkout' }" class="py-2 px-12 rounded md:mr-4 underline text-center"
          @click.native="toStep1">
          ←回上頁
        </router-link>
      </div>
    </div>
    <!-- 第三步 -->
    <div v-if="stepNum === 'step3' && cartList && cartList.length > 0 && status.isShopping" class="step3 mx-auto">

      <CartSection :products="products" :stepNum="stepNum" :events="events" :gifts="gifts" v-if="products !== null" />

      <div class="flex mb-4 flex-wrap">
        <div class="w-full md:w-1/2 p-4 md:p-6 border border-gray-500 rounded">
          <RecipientInfo :loveCode="loveCode" :shoppingInfo="shoppingInfo" :invoice_type="'3'" :invoice_carrier_type="invoice_carrier_type" />
        </div>
        <div class="w-full md:w-1/2 py-4 md:py-6 px-1 md:px-4">
          <Money
            :total="total"
            :eventDiscount="paymentInfo.eventDiscount"
            :shipping="paymentInfo.shipping_fee"
            :calcAmount="calcAmount"
            :percentage="paymentInfo.percentage"
            :magazine_shipping_fee="paymentInfo.magazine_shipping_fee"
          />
          <div class="px-2">
            <p class="mb-2 leading-loose text-sm" v-if="paymentInfo.payment === 'ATM'">請依照指示於下訂單24小時內完成轉帳，系統會自動對帳，您無需來電或寄信通知。若超過期限，訂單將自動取消。</p>
            <p class="mb-2 leading-loose text-sm" v-if="paymentInfo.payment === 'CreditCard'">請點選以下按鈕並完成信用卡線上刷卡程序，刷卡成功才算完成購物流程!感謝您的購買。</p>
            <p class="leading-loose text-sm" v-if="paymentInfo.payment === 'COD'">※下單前請再次確認您的購買明細及配送資訊，訂單成立後無法異動訂單內容</p>
          </div>
        </div>
      </div>
      <div class="flex justify-center md:justify-end md:px-4">
        <!-- <a class="py-2 px-8 rounded md:mr-4 hidden md:block border notEdit" v-if="status.isPaying">
          修改訂單資料
        </a> -->
        <!-- <router-link class="py-2 px-8 rounded md:mr-4 hidden md:block border button-black" :disabled="status.isPaying" v-if="!status.isPaying"
          :to="{ name: 'checkout' }">
          修改訂單資訊
        </router-link> -->
        <router-link class="py-2 px-8 rounded md:mr-4 hidden md:block border button-black" :disabled="status.isPaying" v-if="!status.isPaying"
          :to="{ name: 'checkout', params: { step: 'step2' } }">
          上一步
        </router-link>
        <button class="md:ml-4 py-2 px-12 rounded text-white w-full md:w-auto notPay border-0 focus:outline-none"
          v-if="status.isPaying">
          處理中
          <font-awesome-icon icon="circle-notch" spin />
        </button>
        <button class="md:ml-4 button-red py-2 px-12 rounded text-white w-full md:w-auto cursor-pointer" v-if="!status.isPaying"
          @click.prevent="finish">
          前往付款
        </button>
      </div>
      <div class="flex justify-center mt-4 px-4 md:hidden">
        <a class="py-2 px-12 rounded md:mr-4 w-full underline notEdit" v-if="status.isPaying">
          ←修改訂單資料
        </a>
        <router-link class="py-2 px-12 rounded md:mr-4 w-full underline" v-if="!status.isPaying"
          :to="{ name: 'checkout', params: { step: 'step2' } }">
            ←修改訂單資料
        </router-link>
      </div>

      <form method="post" :action="$store.state.apiUrl + '/web/payment/creditcard'" target="_self"
        v-if="orderNumber !== null" ref="creditPay">
        <input type="hidden" name="ordernumber" :value="orderNumber">
        <input type="hidden" name="amount" :value="calcAmount">
        <input type="hidden" name="itemDesc" value="LiveABC EC Products">
      </form>

    </div>
    <!-- 第四步 -->
    <div v-if="stepNum === 'step4'">
      <OrderFinish :orderNumber="orderNumber" :ATMpayment="ATMpayment" :isOnlyCredit="isOnlyCredit" :calcAmount="calcAmount" />
    </div>

  </div>
</template>

<script>
/* eslint-disable no-unused-expressions */
import axios from 'axios'
import Cart from '@/components/modules/addCart'
import Regex from '@/components/modules/regex'
import CouponInput from '@/components/checkout/Coupon'
import { mapGetters, mapActions } from 'vuex'
import Address from '@/components/modules/AddressSection'
import OrderFinish from '@/components/checkout/OrderFinish'
import Breadcrumb from '@/components/checkout/Breadcrumb'
import CartSection from '@/components/checkout/CartSection'
import Money from '@/components/checkout/Money'
import RelatedEvents from '@/components/modules/RelatedEvents'
import RecipientInfo from '@/components/checkout/RecipientInformation'
import PaymentMethod from '@/components/checkout/PaymentMethod'
import CaptchaPop from '@/components/checkout/CaptchaPop'
import checkForm from '@/components/checkout/checkForm'
import updatedMember from '@/components/checkout/updatedMember'
import SelectAddress from '@/components/checkout/SelectAddressList'
import VueSelectComponent from '@/components/checkout/VueSelect'
import jump from 'jump.js'
import onbeforeunload from '@/components/modules/onbeforeunload'
import ga4 from '@/components/modules/ga4'
import meta from '@/components/modules/meta'
import sweetAlert from '@/components/modules/sweetAlert'
import FreeGift from '@/components/checkout/FreeGift'
import countryJson from '@/components/modules/countryCode.json'
export default {
  name: 'Checkout',
  metaInfo () {
    return {
      title: '購物車',
      titleTemplate: null
    }
  },
  data: () => ({
    countryJson: countryJson,
    events: [],
    gifts: [],
    products: null,
    loveCode: null,
    isSelectAddress: false,

    status: {
      // 購物流程中
      isShopping: false,
      // 結帳中
      isPaying: false,
      // 檢查email中
      isCheckingAccount: false
    },

    // 運費門檻
    free_shipping: 0,
    is_digital: false,

    paymentInfo: {
      // 付款資訊
      country: 'Taiwan',
      payment: 'ATM',
      shipping: 'COD',
      // 運費
      shipping_fee: 0,
      // 訂閱掛號運費
      magazine_shipping_fee: 0,
      // 活動折扣
      eventDiscount: 0,
      // 折扣碼
      couponCode: null,
      // 小計
      subtotal: 0,
      // 訂單折扣
      percentage: 0,
      percentageDiscount: 0,
      // 總金額
      total: 0
    },
    shoppingInfo: {
      user: {
        // 訂購人資訊
        name: null,
        country_code: '+886',
        phone: null,
        tel: null,
        zip_code: null,
        city: null,
        district: null,
        address: null,
        email: null,
        pwd: null,
        pwdCheck: null
      },
      recipient: {
        // 收件人資訊
        id: null,
        name: '',
        country_code: '+886',
        phone: '',
        tel: '',
        zip_code: '',
        city: '',
        district: '',
        address: '',
        selectedData: null
      },
      delivery: {
        eGUIType: 0,
        // 發票資訊
        invoice_type: '31',
        // 電子發票存取方式
        // invoice_carrier_type: '1',
        // 是捐贈
        invoice_giving: false,
        // 是否寄送紙本
        invoice_send: false,
        isAutocomplete: false,
        invoice_donation: '001',

        // 電子發票_會員載具
        invoice_zip_code: null,
        invoice_city: null,
        invoice_district: null,
        invoice_address: null,
        // 電子發票_內容
        invoice_carrier: '',
        // 統編
        taxNum: null,
        taxName: null
      },
      remark: '',
      // 同意訂閱
      isAgreeReceiveDM: true,
      // 同意隱私權/服務條款
      isAgreePolicy: false,
      invoice_auth: true,

      school: ''
    },
    orderNumber: null,

    // 驗證
    isShowCaptchaVerify: false,
    verifyStatus: '',

    // 更新會員資料
    isUpdatedMember: true,
    isSameShoppingInfoAddress: false,

    // 外島
    isOutIsland: false,
    ATMpayment: null,

    agreements: null,

    // onloadTime: null,

    // 放棄贈品
    agreeEmptyGifts: false,
    // 允許繼續購物
    allow_checkout: true,
    // 錯誤訊息
    errors: null,

    // 滿額贈
    selectedGift: []
  }),
  components: {
    CouponInput,
    Address,
    OrderFinish,
    Breadcrumb,
    CartSection,
    Money,
    RelatedEvents,
    RecipientInfo,
    PaymentMethod,
    CaptchaPop,
    SelectAddress,
    VueSelectComponent,
    FreeGift
  },
  mixins: [
    Cart,
    Regex,
    checkForm,
    updatedMember,
    onbeforeunload,
    ga4,
    sweetAlert,
    meta
  ],
  watch: {
    '$route' (to, from) {
      if ((from.params.step && from.params.step === 'step4')) {
        this.status.isShopping = false
      }
    },
    'status.isShopping': {
      immediate: true,
      handler (newValue) {
        if (!newValue && (this.stepNum === 'step2' || this.stepNum === 'step3')) {
          this.$router.push({ name: 'index' })
        }
      }
    },
    'products': {
      immediate: true,
      handler (newValue, oldValue) {
        if (!this.stepNum && (!newValue || newValue.length === 0) && oldValue && oldValue.length > 0) {
          this.alertPop('warning', 'Oops！你的購物車清空囉，請繼續選購商品吧！')
        }
      }
    }
  },
  computed: {
    ...mapGetters(['authorized', 'user', 'cartList', 'userRole']),

    stepNum () {
      return this.$route.params.step || ''
    },

    // 商品總金額
    total () {
      return this.paymentInfo.subtotal
    },

    // 最後總金額
    calcAmount () {
      return this.paymentInfo.total
    },
    invoice_carrier_type () {
      let type = this.shoppingInfo.delivery.invoice_type
      if (type === '31') return '1'
      if (type === '32') return '2'
      if (type === '33' || type === '330') return '3'
      return ''
    },
    digitalCount () {
      let count = 0
      if (this.products && this.products.length > 0) {
        for (let child of this.products) {
          if (child.is_digital) {
            count += child.quantity
          }
        }
      }
      return Number(count)
    },

    isDisabledCOD () {
      if (this.products && this.products.length > 0) {
        for (let item of this.products) {
          if (item.is_digital) {
            return true
          }
        }

        if (this.is_digital) {
          return true
        }

        return false
      } else {
        return false
      }
    },
    isOnlyCredit () {
      if (!this.events) return false
      let eventIds = new Set([80, 81, 93, 29])
      return this.events.some(e => eventIds.has(e.id))
    },
    isOnlyCreditATM () {
      if (!this.products) return false
      let linkIds = new Set([7186, 7188, 7190, 7192])
      return this.products.some(p => linkIds.has(p.link_id))
    },

    postApi () {
      const source = this.$cookie.get('utm_source')
      const baseUrl = '/cart/checkout'

      const sourceMap = {
        shopback: () => `?utm_source=shopback&sbid=${this.$cookie.get('sbid')}`,
        ichannels: () => `?utm_source=ichannels&gid=${this.$cookie.get('ichannels')}`,
        affiliates: () => `?utm_term=${this.$cookie.get('utm_term')}&utm_source=affiliates&utm_medium=cpa`
      }

      var queryString = (sourceMap[source] && sourceMap[source]()) || ''
      return baseUrl + (queryString ? `?${queryString.replace(/^\?/, '')}` : '')
    },

    freeGift_data () {
      if (this.events) {
        return this.events.filter((item) => item.gift_options && item.gift_options.length > 0)
      }
      return null
    }
  },
  mounted () {
    this.getLoveCode()
    this.judgeAPI()
  },
  beforeDestroy () {
    this.$data.shoppingInfo = this.$options.data().shoppingInfo
  },
  methods: {
    ...mapActions({
      dologin: 'login'
    }),
    async judgeAPI () {
      await this.$store.dispatch('isLoading', true)
      await this.$store.dispatch('updateCart')
      await new Promise(resolve => setTimeout(resolve, 1500))
      this.checkCart()
      this.$store.dispatch('isLoading', false)
    },
    getLoveCode () {
      axios.get('/cart/lovecode/list')
        .then((response) => {
          this.loveCode = response.data
        })
    },

    getSelectGiftItem (id) {
      if (this.selectedGift.length > 0) {
        let index = this.selectedGift.findIndex(x => x.id === id)
        if (index > -1) {
          return this.selectedGift[index].selected_gifts
        }
        return []
      } else {
        return []
      }
    },

    getSelectGift (getSelectGift) {
      let index = this.selectedGift.findIndex(x => x.id === getSelectGift.id)

      if (index > -1) {
        if (getSelectGift.selected_gifts.length > 0) {
          this.selectedGift[index] = getSelectGift
        } else {
          this.selectedGift.splice(index, 1)
        }
      } else {
        this.selectedGift.push(getSelectGift)
      }

      this.$nextTick(() => {
        this.judgeAPI()
      })
    },

    async checkCart () {
      this.$store.dispatch('isLoading', true)

      let items = JSON.parse(JSON.stringify(this.cartList)) || []

      if (!items) {
        this.products = null
        this.$store.dispatch('isLoading', false)
        return
      }

      // 組裝請求參數
      let checkData = {
        items,
        isOutIsland: this.isOutIsland,
        sId: localStorage.getItem('sId') || '',
        coupon: this.paymentInfo.couponCode,
        payment_type: this.paymentInfo.payment,
        event_selected_gifts: this.freeGift_data && this.selectedGift.length > 0 ? this.selectedGift : []
      }

      // 發送請求
      axios.post('/cart/check', checkData)
        .then((response) => {
          let data = response.data

          // 更新購物車狀態
          this.products = data.items
          this.paymentInfo = {
            ...this.paymentInfo,
            eventDiscount: data.discount,
            subtotal: data.subtotal,
            total: data.total,
            shipping_fee: data.shipping_fee,
            magazine_shipping_fee: data.magazine_shipping_fee,
            percentage: Number(data.percentage)
          }
          this.events = data.events
          this.gifts = data.gifts
          this.free_shipping = data.free_shipping
          this.is_digital = data.is_digital
          this.allow_checkout = data.allow_checkout
          this.errors = data.errors || null
          this.agreements = { ...data.agreements, isAgree: false }

          this.checkResponse(response.data.items)

          // ga4
          this.view_cart(data)
        })
        .catch((err) => {
          console.error(err.response)
        })
        .finally(() => {
          this.$store.dispatch('isLoading', false)
        })
    },

    checkResponse (data) {
      const responseQuantity = data.reduce((sum, item) => sum + (item.quantity || 0), 0)
      const cartQuantity = this.cartList.reduce((sum, item) => sum + (item.quantity || 0), 0)
      if (data.length !== this.cartList.length || responseQuantity !== cartQuantity) {
        this.$store.dispatch('postCart', this.cleanItems(data))
      }
    },

    // 未登入檢查帳號是否存在
    async verifyEmail () {
      if (this.rexEmail(this.shoppingInfo.user.email) && this.shoppingInfo.user.email) {
        let url = `/account/verify?account=${this.shoppingInfo.user.email}`
        this.status.isCheckingAccount = true

        await axios.get(url)
          .then((response) => {
            this.verifyStatus = response.data
            this.isShowCaptchaVerify = true
            this.status.isCheckingAccount = false
          })
          .catch(() => {
            this.status.isCheckingAccount = false
          })
      }
    },

    // 已登入未驗證通過
    async userVerifyEmail () {
      let url = '/user/verify/mail'
      this.status.isCheckingAccount = true
      await axios.get(url)
        .then((response) => {
          this.verifyStatus = response.data
          this.isShowCaptchaVerify = true
          this.status.isCheckingAccount = false
        })
        .catch(() => {
          this.status.isCheckingAccount = false
        })
    },

    // 關閉驗證emil彈跳視窗
    closeEmailPop (closeEmailPop) {
      this.isShowEmailVerify = closeEmailPop
      this.isShowCaptchaVerify = closeEmailPop
    },
    // 驗證碼通過
    isCodeVerify (isCodeVerify) {
      this.validation.isEmailVerify = isCodeVerify
    },

    // 會員資料
    setUser () {
      if (!this.authorized || !this.user) {
        this.validation.isEmailVerify = false
        return
      }

      this.$store.dispatch('getProfile')

      const user = this.user || {}
      const delivery = this.shoppingInfo.delivery || {}
      const shoppingUser = this.shoppingInfo.user || {}
      const recipient = this.shoppingInfo.recipient || {}

      const { contact_info, country_code, ...rest } = user

      // 帶入寄件人資料
      this.shoppingInfo.user = {
        ...rest,
        country_code: user.country_code || '+886',
        phone: user.mobile || '',
        tel: ''
      }

      // 發票捐贈資料
      delivery.invoice_donation = Array.isArray(user.invoice_donation) && user.invoice_donation.length > 0
        ? user.invoice_donation
        : null

      // 收件人 ID 與完整地址物件
      if (contact_info && contact_info.id && Object.keys(contact_info).length > 0) {
        recipient.id = contact_info.id
        recipient.selectedData = contact_info
      }

      // 發票地址（限電子發票且發票類型為 31）
      const isEGUI = delivery.eGUIType === 0 && delivery.invoice_type === '31'
      delivery.invoice_city = isEGUI ? contact_info?.city || '' : ''
      delivery.invoice_district = isEGUI ? contact_info?.district || '' : ''
      delivery.invoice_address = isEGUI ? contact_info?.address || '' : ''

      // 帶入收件人資料
      const hasRecipientData =
        contact_info?.name &&
        contact_info?.mobile &&
        contact_info?.city &&
        contact_info?.district &&
        contact_info?.tel &&
        shoppingUser?.address

      if (hasRecipientData) {
        recipient.name = contact_info?.name || user.name || ''
        recipient.phone = contact_info?.mobile || user.mobile || ''
        recipient.city = contact_info?.city || ''
        recipient.district = contact_info?.district || ''
        recipient.address = contact_info?.address || ''
        recipient.tel = contact_info?.tel || ''
        recipient.country_code = user.country_code || '+886'
      }

      this.validation.isEmailVerify = !!user.email_verified_at
    },
    // 收件地址
    getOrderAddress (getOrderAddress) {
      this.shoppingInfo.user.zip_code = getOrderAddress.zip_code
      this.shoppingInfo.user.city = getOrderAddress.city
      this.shoppingInfo.user.district = getOrderAddress.district
    },
    // 中獎地址
    getWinAddress (getWinAddress) {
      this.shoppingInfo.delivery.invoice_zip_code = getWinAddress.zip_code
      this.shoppingInfo.delivery.invoice_city = getWinAddress.city
      this.shoppingInfo.delivery.invoice_district = getWinAddress.district
    },
    // 電子發票
    setInvoiceType (invoiceType) {
      if (invoiceType !== this.shoppingInfo.delivery.eGUIType) {
        this.shoppingInfo.delivery.eGUIType = invoiceType
        this.validation.taxNum = true
        this.validation.taxName = true
        this.validation.invoice_address = true
        this.validation.invoice_carrier = true
        this.validation.rex_invoice_carrier = true
        this.validation.isInputLoveCode = true
        this.validation.isBarCode = true
        if (invoiceType === 0 && (this.shoppingInfo.delivery.invoice_type === '0' || this.shoppingInfo.delivery.invoice_type === '330')) {
          this.shoppingInfo.delivery.invoice_type = '31'
        } else if (invoiceType === 2) {
          this.shoppingInfo.delivery.invoice_giving = false
        }
      }
    },
    // 存取方式
    setInvoiceUser () {
      let type = this.shoppingInfo.delivery.invoice_type
      this.validation.taxNum = true
      this.validation.taxName = true
      this.validation.invoice_address = true
      this.validation.invoice_carrier = true
      this.validation.rex_invoice_carrier = true
      this.validation.isInputLoveCode = true
      this.validation.isBarCode = true
      if (type === '31' && this.authorized) {
        this.shoppingInfo.delivery.invoice_carrier = this.user.id
        this.shoppingInfo.delivery.invoice_send = false
      } else if (type === '32' || type === '33') {
        this.shoppingInfo.delivery.invoice_carrier = ''
        this.shoppingInfo.delivery.invoice_send = false
      } else if (type === '0' || type === '330') {
        this.shoppingInfo.delivery.invoice_send = true
      }
    },
    // 至購物車首頁
    toStep1 () {
      this.status.isShopping = false
    },
    // 至填寫使用者資訊頁
    toStep2 () {
      if (!this.allow_checkout && this.errors && this.errors.length > 0) {
        let arr = ''
        for (let item of this.errors) {
          arr += item.msg + '<br/>'
        }

        this.$swal({
          title: arr,
          confirmButtonText: 'OK',
          confirmButtonColor: '#484848',
          width: 400,
          icon: 'error',
          customClass: {
            title: 'text-xl',
            confirmButton: 'bgLiveABCRed'
          }
        })
      } else {
        if (!this.allow_checkout && this.errors && this.errors.length === 0) {
          this.agreeEmptyGifts = true
        }

        if (this.digitalCount > 20) {
          this.alertPop('warning', '已達電腦互動學習軟體購買上限（20筆）')
          // this.$store.dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '已達電腦互動學習軟體購買上限（20筆）', type: 'alert' })
        } else if ((this.products !== null && (this.products.length > 0 || Object.keys(this.products).length > 0)) && this.digitalCount <= 20) {
          this.$router.push({ name: 'checkout', params: { step: 'step2' } })
          this.status.isShopping = true

          // ga4
          this.begin_checkout(this.products)
          jump(this.$refs.breadcrumb, {
            duration: 100,
            offset: -115
          })
          this.setUser()
        }
      }
    },
    // 至填寫訂單確認頁&檢查欄位
    // async toStep3 () {
    //   let isCheckFormStatus = await this.checkFormDevelope()
    //   let isCheckContract = await this.checkoutContract()
    //   if (this.products !== null && (this.products.length > 0 || Object.keys(this.products).length > 0) && isCheckFormStatus && this.shoppingInfo.isAgreePolicy && isCheckContract) {
    //     // 欄位都有填
    //     this.judgeAPI()
    //     this.$router.push({ name: 'checkout', params: { step: 'step3' } })

    //     jump('#app', {
    //       duration: 0,
    //       offset: 0
    //     })
    //   } else if (!this.validation.isCODandOutland) {
    //     // 離島+貨到
    //     this.alertPop('warning', '離島地區僅支援「 線上刷卡 」及「 虛擬ATM 」兩種付款方式，請回上一頁重新勾選。')
    //   } else if (this.products && (this.products.length > 0 || Object.keys(this.products).length > 0) && isCheckFormStatus && (!this.shoppingInfo.isAgreePolicy || !isCheckContract)) {
    //     // 未勾選同意
    //     this.alertPop('warning', '請勾選同意接受LiveABC「服務條款」與「隱私權政策」')
    //   } else {
    //     this.jumpFuncDevelope()
    //   }
    // },
    async toStep3 () {
      const hasProduct = this.products && (this.products.length > 0 || Object.keys(this.products).length > 0)
      const isFormValid = await this.checkFormDevelope()
      const isContractSigned = await this.checkoutContract()
      const isPolicyAgreed = this.shoppingInfo.isAgreePolicy
      const isCODValid = this.validation.isCODandOutland

      // 離島 + 貨到付款
      if (!isCODValid) {
        this.alertPop('warning', '離島地區僅支援「 線上刷卡 」及「 虛擬ATM 」兩種付款方式，請回上一頁重新勾選。')
        return
      }

      // 有商品、欄位有填但未勾選條款 or 合約
      if (hasProduct && isFormValid && (!isPolicyAgreed || !isContractSigned)) {
        this.alertPop('warning', '請勾選同意接受LiveABC「服務條款」與「隱私權政策」')
        return
      }

      // 所有條件都符合 → 進入 step3
      if (hasProduct && isFormValid && isPolicyAgreed && isContractSigned) {
        // this.judgeAPI()
        this.$router.push({ name: 'checkout', params: { step: 'step3' } })

        jump('#app', {
          duration: 0,
          offset: 0
        })
        return
      }

      // 預設錯誤流程（可能是表單沒填完）
      this.jumpFuncDevelope()
    },

    // 填寫訂單完成頁
    // async finish () {
    //   if (this.products !== null && (this.products.length > 0 || Object.keys(this.products).length > 0)) {
    //     this.status.isPaying = true
    //     this.checkout()
    //   }

    //   // 更新會員資料
    //   this.isUpdatedMember && this.authorized ? this.updateMember() : null
    // },
    async finish () {
      const hasProduct = this.products && (this.products.length > 0 || Object.keys(this.products).length > 0)

      if (hasProduct) {
        this.status.isPaying = true
        await this.checkout()
      }

      if (this.isUpdatedMember && this.authorized) {
        this.updateMember()
      }
    },
    // 送出訂單
    // async checkout () {
    //   let checkoutInfo = {
    //     sId: localStorage.getItem('sId') ? localStorage.getItem('sId') : '',
    //     items: this.products,

    //     name: this.shoppingInfo.recipient.name,
    //     country: '台灣',
    //     city: this.shoppingInfo.recipient.city,
    //     district: this.shoppingInfo.recipient.district,
    //     address: this.shoppingInfo.recipient.address,
    //     zip_code: this.shoppingInfo.recipient.zip_code,
    //     country_code: this.shoppingInfo.recipient.country_code,
    //     mobile: this.shoppingInfo.recipient.phone,
    //     phone: this.shoppingInfo.recipient.tel ? this.shoppingInfo.recipient.tel : '',

    //     isOutIsland: this.isOutIsland,
    //     // 付款資訊
    //     payment_type: this.paymentInfo.payment,

    //     // 發票資訊
    //     invoice_type: '3',
    //     invoice_carrier_type: this.invoice_carrier_type,
    //     invoice_address: this.shoppingInfo.delivery.eGUIType === 0 && this.invoice_carrier_type === '1' ? this.shoppingInfo.delivery.invoice_zip_code + this.shoppingInfo.delivery.invoice_city + this.shoppingInfo.delivery.invoice_district + this.shoppingInfo.delivery.invoice_address : '',
    //     invoice_donation: this.shoppingInfo.delivery.invoice_giving ? this.shoppingInfo.delivery.invoice_donation : '',

    //     tax_no: this.shoppingInfo.delivery.eGUIType === 2 ? this.shoppingInfo.delivery.taxNum : '',
    //     tax_title: this.shoppingInfo.delivery.eGUIType === 2 ? this.shoppingInfo.delivery.taxName : '',
    //     invoice_send: this.shoppingInfo.delivery.eGUIType === 2 ? this.shoppingInfo.delivery.invoice_send : false,
    //     // 同意捐贈
    //     invoice_giving: this.shoppingInfo.delivery.invoice_giving,
    //     // 同意退貨
    //     invoice_auth: this.shoppingInfo.invoice_auth,

    //     // 未登入資訊
    //     account: !this.authorized ? this.shoppingInfo.user.email : '',
    //     password: !this.authorized ? this.shoppingInfo.user.pwd : '',

    //     // 接收優惠
    //     isAgreeReceiveDM: this.shoppingInfo.isAgreeReceiveDM,

    //     // 折扣碼
    //     coupon: this.paymentInfo.couponCode
    //   }
    //   if (this.shoppingInfo.school && this.shoppingInfo.remark) {
    //     checkoutInfo.remark = this.shoppingInfo.school + ' / ' + this.shoppingInfo.remark
    //   } else if (this.shoppingInfo.school && !this.shoppingInfo.remark) {
    //     checkoutInfo.remark = this.shoppingInfo.school
    //   } else {
    //     checkoutInfo.remark = this.shoppingInfo.remark
    //   }
    //   if (this.shoppingInfo.delivery.eGUIType === 0 && this.invoice_carrier_type === '1') {
    //     checkoutInfo.invoice_carrier = this.authorized ? this.user.id : ''
    //   } else if ((this.shoppingInfo.delivery.eGUIType === 0 && (this.invoice_carrier_type === '2' || this.invoice_carrier_type === '3')) || this.shoppingInfo.delivery.eGUIType === 2) {
    //     checkoutInfo.invoice_carrier = this.shoppingInfo.delivery.invoice_carrier
    //   }
    //   checkoutInfo.agreeEmptyGifts = this.agreeEmptyGifts

    //   if (this.freeGift_data) {
    //     checkoutInfo.event_selected_gifts = this.selectedGift
    //   }

    //   this.$store.state.nodeEnv !== 'production' ? console.log(checkoutInfo) : null

    //   let postAPI = this.postApi
    //   this.$store.dispatch('isLoading', true)

    //   await axios.post(postAPI, checkoutInfo)
    //     .then((response) => {
    //       this.orderNumber = response.data.order_id
    //       this.checkoutFinishCode(response.data.order_id, this.products, this.calcAmount)

    //       // ga4
    //       this.purchase_track(response.data, this.products)
    //       this.add_payment_info(this.products)
    //       this.add_shipping_info(this.products)
    //       // google
    //       this.gtag_purchase_track(response.data, this.products)
    //       // meta
    //       this.meta_purchase_track(response.data, this.products)
    //     })
    //     .then(() => {
    //       this.removeShoppingList()
    //       this.authorized ? this.payment_method() : this.firstUserRegister()
    //       this.$store.dispatch('isLoading', false)
    //     })
    //     .catch((error) => {
    //       this.$store.dispatch('isLoading', false)
    //       this.$swal({
    //         title: (error.response && error.response.data && error.response.data.msg) ? error.response.data.msg : '系統錯誤，請聯繫客服為您處理',
    //         confirmButtonText: '確定',
    //         confirmButtonColor: '#484848',
    //         width: 400,
    //         icon: 'error',
    //         customClass: {
    //           title: 'text-xl',
    //           confirmButton: 'bgLiveABCRed'
    //         }
    //       }).then(() => {
    //         this.$router.push({ name: 'index' })
    //       })
    //     })
    //     .finally(() => {
    //       this.removeShoppingList()
    //       this.authorized ? this.payment_method() : this.firstUserRegister()
    //       this.$store.dispatch('isLoading', false)
    //     })
    // },
    async checkout () {
      // 1. 資料準備：將複雜的判斷邏輯提取出來，讓 Payload 更乾淨
      const { recipient, delivery, user, school, remark, invoice_auth, isAgreeReceiveDM } = this.shoppingInfo

      // 處理備註邏輯 (自動過濾空值並用 " / " 串接)
      const remarkText = [school, remark].filter(Boolean).join(' / ')

      // 處理發票地址邏輯
      const isMobileCarrier = this.invoice_carrier_type === '1'
      const isStandardInvoice = delivery.eGUIType === 0
      const fullInvoiceAddress = (isStandardInvoice && isMobileCarrier)
        ? `${delivery.invoice_zip_code}${delivery.invoice_city}${delivery.invoice_district}${delivery.invoice_address}`
        : ''

      // 處理載具邏輯
      let invoiceCarrier = ''
      if (isStandardInvoice && isMobileCarrier) {
        invoiceCarrier = this.authorized ? this.user.id : ''
      } else if ((isStandardInvoice && ['2', '3'].includes(this.invoice_carrier_type)) || delivery.eGUIType === 2) {
        invoiceCarrier = delivery.invoice_carrier
      }

      // 2. 建立 Payload
      const checkoutInfo = {
        sId: localStorage.getItem('sId') || '',
        items: this.products,

        // 收件人
        name: recipient.name,
        country: '台灣',
        city: recipient.city,
        district: recipient.district,
        address: recipient.address,
        zip_code: recipient.zip_code,
        country_code: recipient.country_code,
        mobile: recipient.phone,
        phone: recipient.tel || '',

        isOutIsland: this.isOutIsland,
        payment_type: this.paymentInfo.payment,

        // 發票
        invoice_type: '3',
        invoice_carrier_type: this.invoice_carrier_type,
        invoice_address: fullInvoiceAddress,
        invoice_donation: delivery.invoice_giving ? delivery.invoice_donation : '',
        invoice_carrier: invoiceCarrier,

        // 公司統編
        tax_no: delivery.eGUIType === 2 ? delivery.taxNum : '',
        tax_title: delivery.eGUIType === 2 ? delivery.taxName : '',
        invoice_send: delivery.eGUIType === 2 ? delivery.invoice_send : false,

        // 同意事項
        invoice_giving: delivery.invoice_giving,
        invoice_auth: invoice_auth,
        agreeEmptyGifts: this.agreeEmptyGifts,
        isAgreeReceiveDM: isAgreeReceiveDM,

        // 會員與登入
        account: !this.authorized ? user.email : '',
        password: !this.authorized ? user.pwd : '',
        coupon: this.paymentInfo.couponCode,
        remark: remarkText
      }

      // 贈品邏輯
      if (this.freeGift_data) {
        checkoutInfo.event_selected_gifts = this.selectedGift
      }
      // Debug Log
      if (this.$store.state.nodeEnv !== 'production') {
        console.log('Checkout Payload:', checkoutInfo)
      }
      // 3. 開始執行 API 請求
      this.$store.dispatch('isLoading', true)

      try {
        const response = await axios.post(this.postApi, checkoutInfo)
        const orderData = response.data
        // --- 成功流程 ---
        this.orderNumber = orderData.order_id
        // this.checkoutFinishCode(orderData.order_id, this.products, this.calcAmount)
        try {
          this.purchase_track(orderData, this.products)
          this.add_payment_info(this.products)
          this.add_shipping_info(this.products)
          this.gtag_purchase_track(orderData, this.products)
          this.meta_purchase_track(orderData, this.products)
        } catch (trackError) {
          console.warn('Tracking code error:', trackError)
        }

        // 5. 清除購物車並跳轉
        this.removeShoppingList()
        if (this.authorized) {
          this.payment_method()
        } else {
          this.firstUserRegister()
        }
      } catch (error) {
        // --- 錯誤流程 ---
        console.error('Checkout Error:', error)
        const errorMsg = error.response?.data?.msg || '系統錯誤，請聯繫客服為您處理'
        await this.$swal({
          title: errorMsg,
          confirmButtonText: '確定',
          confirmButtonColor: '#484848',
          width: 400,
          icon: 'error',
          customClass: {
            title: 'text-xl',
            confirmButton: 'bgLiveABCRed'
          }
        })
        this.$router.push({ name: 'index' })
      } finally {
        this.$store.dispatch('isLoading', false)
      }
    },
    // 未登入先註冊
    async firstUserRegister () {
      await this.dologin({ account: this.shoppingInfo.user.email, password: this.shoppingInfo.user.pwd })
      this.payment_method()
    },

    // 依付款方式付款
    async payment_method () {
      const { payment } = this.paymentInfo
      const orderNumber = this.orderNumber

      try {
        if (payment === 'CreditCard') {
          console.log(this.$refs.creditPay)
              // 信用卡
              // await this.$nextTick()
              // this.$refs.creditPay.submit()
          // await this.waitForOrderNumber()

          // 等 DOM render 好（v-if / v-show）
          // await this.$nextTick()

          // 確保 ref 存在
          // if (this.$refs.creditPay) {
          //   this.$refs.creditPay.submit()
          // } else {
          //   console.error('creditPay form not found')
          // }
          // this.$refs.creditPay.submit()

        } else if (payment === 'ATM') {
          // 虛擬ATM付款
          const response = await axios.post(`/payment/atm/order/${orderNumber}`)
          this.ATMpayment = response.data
          this.$router.push({
            name: 'checkout',
            params: { step: 'step4' },
            query: { ordernumber: orderNumber }
          })
        } else if (payment === 'COD') {
          // 貨到付款
          this.$router.push({
            name: 'checkout',
            params: { step: 'step4' },
            query: { ordernumber: orderNumber }
          })
        }
      } catch (error) {
        console.error('Payment error:', error)
      } finally {
        this.status.isShopping = false
      }
    },
    async waitForOrderNumber(timeout = 10000) {
      if (this.orderNumber) return this.orderNumber

      return new Promise((resolve, reject) => {
        const start = Date.now()
        const timer = setInterval(() => {
          if (this.orderNumber) {
            clearInterval(timer)
            resolve(this.orderNumber)
          }

          if (Date.now() - start > timeout) {
            clearInterval(timer)
            reject(new Error('waitForOrderNumber timeout'))
          }
        }, 100)
      })
    },
    // 刪除購物車商品
    removeShopItem () {
      this.judgeAPI()
    },
    paymentType (paymentType) {
      this.paymentInfo.country = paymentType.country
      this.paymentInfo.payment = paymentType.type
      this.paymentInfo.shipping = paymentType.shipping

      this.judgeAPI()
    },

    // 折扣券金額
    setCoupon (setCoupon) {
      if (setCoupon.code !== '') {
        // 有驗證碼
        this.paymentInfo.couponCode = setCoupon
        this.judgeAPI()
      } else {
        // 沒有驗證碼
        this.paymentInfo.couponCode = ''
        this.judgeAPI()
      }
    },

    // 收件人相關
    closeSelectAddress (closeSelectAddress) {
      this.isSelectAddress = closeSelectAddress
    },

    selectedAdd (selectedAdd) {
      const recipient = this.shoppingInfo.recipient
      const fieldMap = {
        id: 'id',
        name: 'name',
        city: 'city',
        mobile: 'phone',
        tel: 'tel',
        zip_code: 'zip_code',
        district: 'district',
        address: 'address'
      }

      for (const [fromKey, toKey] of Object.entries(fieldMap)) {
        recipient[toKey] = selectedAdd[fromKey]
      }
      recipient.country_code = selectedAdd.country_code || '+886'

      recipient.selectedData = selectedAdd

      this.closeSelectAddress()
    },
    getAddressRecipient (getAddressRecipient) {
      const r = this.shoppingInfo.recipient
      const city = getAddressRecipient.city
      const district = getAddressRecipient.district
      // 設定基本地址資料
      r.zip_code = getAddressRecipient.zip_code
      r.city = city
      r.district = district

      // 判斷是否為離島
      const OUTLYING_ISLANDS = ['南海島', '澎湖縣', '金門縣', '釣魚台', '連江縣']
      const isOutIsland = OUTLYING_ISLANDS.includes(city) || (city === '屏東縣' && district === '琉球鄉')
      this.isOutIsland = isOutIsland

      if (isOutIsland) {
        const isCOD = this.paymentInfo.payment === 'COD'

        if (isCOD) {
          this.alertPop('warning', '離島地區僅支援「 線上刷卡 」及「 虛擬ATM 」兩種付款方式，請回上一頁重新勾選。')
          this.validation.isCODandOutland = false
        } else {
          this.alertPop('warning', '您選擇的收件地址為離島地區，需「 額外 」加收210元運費。')
          this.validation.isCODandOutland = true
        }
      } else {
        this.validation.isCODandOutland = true
      }

      // 通知系統有地址異動
      this.setAddressId()
    },

    // getAddressRecipient (getAddressRecipient) {
    //   this.shoppingInfo.recipient.zip_code = getAddressRecipient.zip_code
    //   this.shoppingInfo.recipient.city = getAddressRecipient.city
    //   this.shoppingInfo.recipient.district = getAddressRecipient.district

    //   let outlyingIsland = ['南海島', '澎湖縣', '金門縣', '釣魚台', '連江縣']
    //   if ((outlyingIsland.indexOf(getAddressRecipient.city) > -1) || (getAddressRecipient.city === '屏東縣' && getAddressRecipient.district === '琉球鄉')) {
    //     if (this.paymentInfo.payment === 'COD') {
    //       this.alertPop('warning', '離島地區僅支援「 線上刷卡 」及「 虛擬ATM 」兩種付款方式，請回上一頁重新勾選。')
    //       this.validation.isCODandOutland = false
    //     } else {
    //       this.alertPop('warning', '您選擇的收件地址為離島地區，需「 額外 」加收210元運費。')
    //     }
    //     this.isOutIsland = true
    //   } else {
    //     this.isOutIsland = false
    //     this.validation.isCODandOutland = true
    //   }

    //   this.setAddressId()
    // },
    setAddressId () {
      let recipient = this.shoppingInfo.recipient
      let selectedData = this.shoppingInfo.recipient.selectedData
      if (selectedData && (recipient.name !== selectedData.name || recipient.city !== selectedData.city || recipient.phone !== selectedData.mobile || recipient.tel !== selectedData.tel || recipient.district !== selectedData.district || recipient.address !== selectedData.address)) {
        this.shoppingInfo.recipient.id = null
      }
    },

    async addAddressData () {
      const r = this.shoppingInfo.recipient
      const isFilled = r.name && r.phone && r.address && r.tel
      const shouldSave = this.authorized && !r.id && isFilled

      if (!shouldSave) return

      const obj = {
        name: r.name,
        mobile: r.phone,
        tel: r.tel,
        city: r.city,
        district: r.district,
        zip_code: r.zip_code,
        address: r.address
      }

      try {
        const result = await this.$swal({
          title: '儲存收件地址為常用通訊錄?',
          showCancelButton: true,
          confirmButtonText: '確定',
          confirmButtonColor: '#e60012',
          cancelButtonColor: '#484848',
          cancelButtonText: '取消',
          width: 400,
          icon: 'question',
          customClass: {
            title: 'text-xl'
          }
        })

        if (result.isConfirmed) {
          const res = await axios.post('/user/recipients', obj)
          this.shoppingInfo.recipient.selectedData = res.data
          this.shoppingInfo.recipient.id = res.data.id
          this.$swal.fire({
            icon: 'success',
            title: '儲存成功',
            showConfirmButton: false,
            timer: 1500
          })
        }
      } catch (err) {
        console.error(err)
        this.$swal.fire({
          icon: 'error',
          title: '儲存失敗，請稍後再試',
          showConfirmButton: false,
          timer: 2000
        })
      }
    },

    inputLoveCode (inputLoveCode) {
      this.shoppingInfo.delivery.invoice_donation = inputLoveCode
    },

    setSamePeopleData () {
      const { user, recipient } = this.shoppingInfo
      const requiredFields = ['name', 'phone', 'city', 'district', 'address']

      if (requiredFields.every(field => user[field])) {
        ['name', 'phone', 'tel', 'address', 'city', 'district', 'country_code'].forEach(field => {
          recipient[field] = user[field]
        })
      }
    },
    setInvoice_address () {
      const { isSameShoppingInfoAddress, shoppingInfo } = this
      const { user, delivery } = shoppingInfo

      if (isSameShoppingInfoAddress && user.address && !delivery.invoice_giving) {
        const fields = ['city', 'district', 'address']
        fields.forEach(field => {
          delivery[`invoice_${field}`] = user[field]
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .donat-selector .vs__clear {
    display: none;
  }
  #checkout {

    .choose {
      background-color: #2C3E50;
      color: white !important;
    }
    .active {
      color: #2C3E50 !important;
      font-weight: 700 !important;
    }
    .disabled {
      cursor: not-allowed;
    }
    .defaultInovice {
      background-color: #cbd5e0 !important;
      color: white !important;
      border-color: #cbd5e0 !important;
      &:hover {
        background-color: #cbd5e0 !important;
        color: white !important;
        border-color: #cbd5e0 !important;
      }
    }
    .notEdit {
      cursor: default !important;
      background-color: #cbd5e0 !important;
      color: white !important;
      border-color: #cbd5e0 !important;
      &:hover {
        background-color: #cbd5e0 !important;
        color: white !important;
        border-color: #cbd5e0 !important;
      }
    }
    .notPay {
      cursor: default !important;
      background-color: #cbd5e0 !important;
      &:hover {
        background-color: #cbd5e0 !important;
      }
    }
    .controls-item {
      input[type="checkbox"] {
        box-sizing: border-box;
        padding: 0;
        margin-right: .4em;
        width: 100%;
        margin-bottom: 10px;
        &:hover + label:before {
          background: #e6e6e6;
        }
      }
      label {
        position: relative;
        display: inline-block;
        padding-left: 16px;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        vertical-align: middle;
      }

      label:before {
        content: '';
        display: inline-block;
        position: absolute;
        top: 8px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        width: 12px;
        height: 12px;
        border: 1px solid #6c6c6c;
        left: 0;
        transition: .2s;
      }
      .labelisTrue:hover + label:before {
        background: #ffffff !important;
      }
      .labelisTrue + label:after {
        content: '';
        display: inline-block;
        position: absolute;
        top: 11px;
        background-color: #383838;
        width: 6px;
        height: 6px;
        left: 3px;
      }
      span {
        line-height: 18px;
      }
    }

    .input-text {
      background-color: white;
      border: 1px solid #cccccc;
      padding: 8px 4px;
      position: relative;
      width: 100%;
      z-index: 3;
    }
  }
</style>
